const tabsOptions = [
  {
    label: 'Informações',
  }, 
  {
    label: 'Auditoria',
  }
]

export default tabsOptions;